import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConversationSideHelper {
  private static conversationSideCache = new Map<string, number>();

  static get(key: string): number {
    return this.conversationSideCache.has(key) ? this.conversationSideCache.get(key) : -1;
  }

  static set(key: string, value: number): void {
    this.conversationSideCache.set(key, value);
  }

  static clear(): void {
    this.conversationSideCache.clear();
  }
}
